import React from 'react';
import { TableRow, TableCell, Box, useTheme } from '@mui/material';
import { Typography } from '@/components/atoms';

export interface EmptyStateProps {
  message?: string;
  icon?: React.ReactNode;
  colSpan?: number;
}

/**
 * EmptyState - Displays a message when the table has no data
 *
 * Features:
 * - Customizable empty message
 * - Optional icon display
 * - Spans across all table columns
 * - Proper styling and centering
 *
 * Can be reused in other parts of the application where empty states are needed
 */
export const EmptyState = ({
  message = 'No data available',
  icon,
  colSpan,
}: EmptyStateProps) => {
  const theme = useTheme();

  return (
    <TableRow>
      <TableCell colSpan={colSpan ?? 1} variant="empty">
        {icon && <Box sx={{ marginBottom: theme.unit(2) }}>{icon}</Box>}
        <Typography color="textSecondary">{message}</Typography>
      </TableCell>
    </TableRow>
  );
};
